import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { KPICard } from '../components/KPICard';
import { Activity, CheckCircle, Clock, MapPin, Users } from 'lucide-react';
import { useUkstrStore } from '../data/ukstrStore';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
export default function UkstrMonitoring() {
  const {
    tasks,
    answers
  } = useUkstrStore();
  const activeTasks = tasks.filter(t => t.status !== 'Selesai').length;
  const totalAnswers = answers.length;
  const verifiedAnswers = answers.filter(a => a.status === 'Diverifikasi' || a.status === 'Digunakan dalam Laporan').length;
  const progress = totalAnswers > 0 ? Math.round(verifiedAnswers / totalAnswers * 100) : 0;
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-4017">
      <div data-id="element-4018">
        <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground uppercase" data-id="element-4019">
          Monitoring Tugas UK/STR
        </h1>
        <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-4020">
          Dashboard Pemantauan Pelaksanaan Tugas Intelijen
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-4021">
        <KPICard title="Tugas Aktif" value={activeTasks.toString()} icon={<Activity className="w-4 h-4 text-primary" data-id="element-4023" />} trend="+2" trendLabel="dari minggu lalu" data-id="element-4022" />
        <KPICard title="Jawaban Masuk" value={totalAnswers.toString()} icon={<Users className="w-4 h-4 text-blue-500" data-id="element-4025" />} trend="+15" trendLabel="dalam 24 jam" data-id="element-4024" />
        <KPICard title="Jawaban Tervalidasi" value={verifiedAnswers.toString()} icon={<CheckCircle className="w-4 h-4 text-[var(--status-active)]" data-id="element-4027" />} trend="+5" trendLabel="hari ini" data-id="element-4026" />
        <KPICard title="Progres Keseluruhan" value={`${progress}%`} icon={<Clock className="w-4 h-4 text-orange-500" data-id="element-4029" />} trend="+10%" trendLabel="peningkatan" data-id="element-4028" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-4030">
        <Card className="lg:col-span-2 glass-panel border-border/50" data-id="element-4031">
          <CardHeader className="p-4 border-b border-border/50 bg-card/50" data-id="element-4032">
            <CardTitle className="text-sm font-mono uppercase tracking-widest text-muted-foreground flex items-center gap-2" data-id="element-4033">
              <MapPin className="w-4 h-4" data-id="element-4034" /> Peta Sebaran Jawaban
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0 h-[400px] relative z-0" data-id="element-4035">
            <MapContainer center={[-2.5489, 118.0149]} zoom={5} style={{
            height: '100%',
            width: '100%',
            background: '#0a0a0a'
          }} zoomControl={false} data-id="element-4036">
              <TileLayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" attribution="&copy; CARTO" data-id="element-4037" />
              <CircleMarker center={[-6.2088, 106.8456]} radius={12} fillColor="var(--primary)" color="var(--primary)" weight={2} fillOpacity={0.4} data-id="element-4038">
                <Popup data-id="element-4039">
                  <div className="text-xs font-mono" data-id="element-4040">
                    DKI Jakarta: 5 Jawaban
                  </div>
                </Popup>
              </CircleMarker>
            </MapContainer>
          </CardContent>
        </Card>

        <Card className="glass-panel border-border/50 flex flex-col overflow-hidden" data-id="element-4041">
          <CardHeader className="p-4 border-b border-border/50 bg-card/50 shrink-0" data-id="element-4042">
            <CardTitle className="text-sm font-mono uppercase tracking-widest text-muted-foreground" data-id="element-4043">
              Status Jawaban Terkini
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 space-y-4 flex-1 overflow-y-auto custom-scrollbar" data-id="element-4044">
            {answers.slice(0, 5).map(ans => <div key={ans.id} className="flex items-start justify-between border-b border-border/30 pb-3 last:border-0 last:pb-0" data-id="element-4045">
                <div data-id="element-4046">
                  <div className="text-xs font-bold text-foreground" data-id="element-4047">
                    {ans.personelName}
                  </div>
                  <div className="text-[10px] font-mono text-muted-foreground" data-id="element-4048">
                    {ans.wilayah} • {ans.waktu}
                  </div>
                </div>
                <div className="text-[10px] font-mono px-2 py-1 rounded border border-primary/30 text-primary bg-primary/10" data-id="element-4049">
                  {ans.status}
                </div>
              </div>)}
          </CardContent>
        </Card>
      </div>
    </div>;
}